/** Mobile Journal (SPEC §17.7, §15.5): month calendar grid with day net + trade count. */
export function Journal(): React.JSX.Element {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const first = new Date(year, month, 1);
  const days = new Date(year, month + 1, 0).getDate();
  const lead = (first.getDay() + 6) % 7; // Monday-first
  const cells: Array<number | null> = [
    ...Array<null>(lead).fill(null),
    ...Array.from({ length: days }, (_, i) => i + 1),
  ];
  const title = first.toLocaleString(undefined, { month: "long", year: "numeric" });
  return (
    <div className="m-journal">
      <div className="m-cal-head">
        <span>{title}</span>
        <span className="muted num">net —</span>
      </div>
      <div className="m-cal">
        {["M", "T", "W", "T", "F", "S", "S"].map((d, i) => (
          <span key={i} className="m-cal-dow muted">
            {d}
          </span>
        ))}
        {cells.map((d, i) => (
          <span key={i} className={d === null ? "m-cal-cell empty" : "m-cal-cell"}>
            {d !== null && <span className="m-cal-day">{d}</span>}
          </span>
        ))}
      </div>
      <p className="muted m-note">Days colour by net P&amp;L once fills are recorded (Phase 9 journal).</p>
    </div>
  );
}
